export default "/* Basic styles */\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}"